const maxRadius = 100000; // 100km
const clickZoom = 11;

let map,infoWindow,storeList,initMarkets,geocoder;
  

function initMap() {
    geocoder = new google.maps.Geocoder();
    map = new google.maps.Map(document.getElementById('map'), {
      zoom: 4, // 地图缩放比例 数字越大越近
      center: {lat: 33.99503, lng: -117.6923}, // 地图中心点 经纬度
    });
    
    map.data.loadGeoJson('https://www.honeyplaybox.com/cdn/shop/t/151/assets/stores.json?v=202504010', {idPropertyName: 'storeid'});

    map.data.setStyle((feature) => {
        return {
            icon: {
                url: `https://www.honeyplaybox.com/cdn/shop/t/151/assets/honey-pin.png`,
                scaledSize: new google.maps.Size(20, 30),
            },
        };
    });
  
    const apiKey = 'AIzaSyB2b1UZWf5yc9COVmTXfJl-g31OclRfHec';
    infoWindow = new google.maps.InfoWindow();
  
    map.data.addListener('click', (event) => {
        showInfoWindow(
            event.feature.getProperty('name'),
            event.feature.getProperty('address'),
            event.feature.getProperty('phone'),
            event.feature.getProperty('email'),
            event.feature.getProperty('website'),
            event.feature.getGeometry().get().lat(),
            event.feature.getGeometry().get().lng()
        );
    });

    setTimeout(() => {
        storeList = map.data;    
        console.log(storeList);
        showStoresList();

        setTimeout(() => {
            const searchIconContainer = document.querySelector('.google-map-section__search-icon');
            searchIconContainer.click();
            console.log('click');
        }, 1000);
    }, 2000);

    document.querySelector('.google-map-section__search-icon').addEventListener('click', async (event) => {
        event.preventDefault();
        const inputValue = document.querySelector('.google-map-section__search input').value.toLowerCase();
        
        await handleSearchInput(inputValue);
    });

    document.querySelector('.google-map-section__search input').addEventListener('keydown', async (event) => {
        if (event.key === 'Enter' || event.keyCode === 13) {
            event.preventDefault();

            const inputValue = event.target.value.toLowerCase();
            
            await handleSearchInput(inputValue);
        }
    });

    document.querySelector('.google-map-section__search input').addEventListener('input', (event) => {
        const inputValue = event.target.value.toLowerCase();
        if (inputValue.length === 0) {
            storeList = map.data;
        }
    });
}

async function handleSearchInput(inputValue) {

    if (inputValue.length > 0) {
        try {
            storeList = await findPlaceFromQuery(inputValue);
            if (storeList.length > 0) {
                map.setZoom(clickZoom);
                map.panTo(storeList[0].getGeometry().get());
                showInfoWindow(
                    storeList[0].getProperty('name'),
                    storeList[0].getProperty('address'),
                    storeList[0].getProperty('phone'),
                    storeList[0].getProperty('email'),
                    storeList[0].getProperty('website'),
                    storeList[0].getGeometry().get().lat(),
                    storeList[0].getGeometry().get().lng()
                );
            }
        } catch (error) {
            console.error('Error searching locations:', error);
            storeList = [];
        }
    } else {
        storeList = map.data;
    }

    showStoresList();
}

async function findNearbyMarkers(center, radiusInMeters) {

    const nearbyMarkers = [];
    const promises = [];
    const {spherical} = await google.maps.importLibrary("geometry")
    
    map.data.forEach(feature => {
        const promise = (async () => {
            const markerPosition = {
                lat: feature.getGeometry().get().lat(),
                lng: feature.getGeometry().get().lng()
              };
              
              const distance = spherical.computeDistanceBetween(
                new google.maps.LatLng(center),
                new google.maps.LatLng(markerPosition)
              );
              
              if (distance <= radiusInMeters) {
                nearbyMarkers.push({
                    'feature': feature,
                    'distance': distance,
                    'name': feature.getProperty('name'),
                    'lat': feature.getGeometry().get().lat(),
                    'lng': feature.getGeometry().get().lng()
                });
              }
        })();

        promises.push(promise);
    });

    await Promise.all(promises);

    nearbyMarkers.sort((a, b) => a.distance - b.distance);
    const features = nearbyMarkers.map(marker => marker.feature);
    
    return features;
}

function showStoresList() {
    let hasInitMarkets = false;
    if (initMarkets) {
        hasInitMarkets = true;
    } else {
        initMarkets = [];
    }

    clearStoreList();
    const listContainer = document.querySelector('.google-map-section__list');
    try {
        const fragment = document.createDocumentFragment();

        if (storeList.style || storeList.length > 0) {
            storeList.forEach(store => {
                if (!hasInitMarkets) {
                    initMarkets.push({
                        lat: store.getGeometry().get().lat(),
                        lng: store.getGeometry().get().lng(),
                        name: store.getProperty('name'),
                    });
                }

                const div = document.createElement('div');
                div.setAttribute('data-lat', store.getGeometry().get().lat());
                div.setAttribute('data-lng', store.getGeometry().get().lng());
                div.setAttribute('onclick', `handleMarkerClick('${store.getGeometry().get().lat()}', '${store.getGeometry().get().lng()}', this, event)`);
                
                div.innerHTML = `
                    <p class="location-name">${store.getProperty('name')}</p>
                    <div class="address location-item">
                        <span>
                            <svg class="location-icon address-icon" fill="none" viewBox="0 0 24 24" stroke="#000000">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            </svg>
                        </span>
                        <span class="address-value">${store.getProperty('address')}</span>
                    </div>
                    ${store.getProperty('phone') ? `
                        <div class="phone location-item item-center">
                            <span>
                                <svg class="telephone-icon location-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 16 16">
                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"></path>
                                </svg>
                            </span>
                            <span class="phone-value">${store.getProperty('phone')}</span>
                        </div>
                    ` : ''}
                    ${store.getProperty('email') ? `
                        <div class="email location-item item-center">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" class="email-icon location-icon">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"></path>
                                </svg>
                            </span>
                            <span class="email-value">${store.getProperty('email')}</span>
                        </div>
                    ` : ''}
                    ${store.getProperty('website') ? `
                        <div class="website location-item item-center">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" class="website-icon location-icon">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"></path>
                                </svg>
                            </span>
                            <span class="website-value"><a href="${store.getProperty('website')}">${store.getProperty('website')}</a></span>
                        </div>
                    ` : ''}
                `;

                fragment.appendChild(div);
            });
        } else {
            const div = document.createElement('div');
            div.setAttribute('class', 'not-stores-found');
            div.innerHTML = `
                <p class="not-stores-found">No stores found</p>
            `;
            fragment.appendChild(div);
        }

        listContainer.appendChild(fragment);
    } catch (e) {
        console.error('initStoresList error: ', e);
    }
}

function handleMarkerClick(lat, lng, target, event) {
    event.preventDefault();

    let nameValue, addressValue, phoneValue, emailValue, websiteValue;

    nameValue = target.querySelector('.location-name').textContent;
    if (target.querySelector('.address-value')) {
        addressValue = target.querySelector('.address-value').textContent;
    }
    if (target.querySelector('.phone-value')) {
        phoneValue = target.querySelector('.phone-value').textContent;
    }
    if (target.querySelector('.email-value')) {
        emailValue = target.querySelector('.email-value').textContent;
    }
    if (target.querySelector('.website-value')) {
        websiteValue = target.querySelector('.website-value').textContent;
    }
    if (event.target.tagName === 'A') {
        const websiteLink = event.target.href;
        if (websiteLink) {
            window.open(websiteLink, '_blank');
        }
    }

    map.setZoom(clickZoom);
    map.setCenter(new google.maps.LatLng(lat, lng));
    showInfoWindow(nameValue, addressValue, phoneValue, emailValue, websiteValue, lat, lng);
}

function showInfoWindow(name, address, phone, email, website, lat, lng) {
    let content = `
        <p class="location-name">${name}</p>
        <div class="address location-item">
            <span>
                <svg class="location-icon address-icon" fill="none" viewBox="0 0 24 24" stroke="#000000">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
            </span>
            <span class="address-value">${address}</span>
        </div>
        ${phone ? `
            <div class="phone location-item item-center">
                <span>
                    <svg class="telephone-icon location-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 16 16">
                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"></path>
                    </svg>
                </span>
                <span class="phone-value">${phone}</span>
            </div>
        ` : ''}
        ${email ? `
            <div class="email location-item item-center">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" class="email-icon location-icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"></path>
                    </svg>
                </span>
                <span class="email-value">${email}</span>
            </div>
        ` : ''}
        ${website ? `
            <div class="website location-item item-center">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" class="website-icon location-icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"></path>
                    </svg>
                </span>
                <span class="website-value"><a href="${website}" target="_blank">${website}</a></span>
            </div>
        ` : ''}
        <a class="google-map-section__link" href="https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}" target="_blank" style="margin-top: 10px;display: inline-block;text-decoration: underline;">Directions</a>
    `;
  
    infoWindow.setContent(content);
    infoWindow.setPosition(new google.maps.LatLng(lat, lng));
    infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
    infoWindow.open(map);
}

async function findPlaceFromQuery(query) {
    return new Promise((resolve, reject) => {
        const request = {
            query: query,
            fields: ['name', 'geometry'],
        };

        const service = new google.maps.places.PlacesService(map);
        service.findPlaceFromQuery(request, async function(results, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
    
                try {
                    const nearbyMarkets = await findNearbyMarkers(results[0].geometry.location, maxRadius);
                    
                    resolve(nearbyMarkets);
                } catch (error) {
                    console.error('Error finding nearby markers:', error);
                    reject(error);
                }
            } else {
                reject(new Error(`API error: ${status}`));
            }
        });
    });
}

async function calculateDistances(data, origin) {
    const stores = [];
    const destinations = [];

    data.forEach((store) => {
      const storeNum = store.getProperty('storeid');
      const storeLoc = store.getGeometry().get();
    
      const index = parseInt(storeNum, 10);

      if (index < 25) {
        stores.push(storeNum);
        destinations.push(storeLoc);
      }
    });
    
    const service = new google.maps.DistanceMatrixService();
    const getDistanceMatrix =
      (service, parameters) => new Promise((resolve, reject) => {
        service.getDistanceMatrix(parameters, (response, status) => {
          if (status != google.maps.DistanceMatrixStatus.OK) {
            reject(new Error(`API error: ${status}`));
          } else {
            const distances = [];
            const results = response.rows[0].elements;

            if (results.length === 0) {
                reject(new Error('No distance data returned'));
            }

            for (let j = 0; j < results.length; j++) {
              const element = results[j];

              if (element.status === 'OK') {
                const distanceText = element.distance.text;
                const distanceVal = element.distance.value;
                const distanceObject = {
                  storeid: stores[j],
                  distanceText: distanceText,
                  distanceVal: distanceVal,
                };

                if (distanceVal < maxRadius) {
                    distances.push(distanceObject);
                }
              }
            }
            
            resolve(distances);
          }
        });
    });
  
    const distancesList = await getDistanceMatrix(service, {
      origins: [origin],
      destinations: destinations,
      travelMode: 'DRIVING',
      unitSystem: google.maps.UnitSystem.METRIC,
    });
  
    distancesList.sort((first, second) => {
      return first.storeid - second.storeid;
    });
  
    return distancesList;
}

function clearStoreList() {
    const listElement = document.querySelector('.google-map-section__list');
    
    if (listElement) {
        listElement.innerHTML = '';
    }
}